import React from 'react';
import { getDateOnly } from '../utils';

type CustomXAxisTickProps = {
  x: number;
  y: number;
  payload: {
    value: string;
  };
  isWeekend: boolean;
};

export const CustomXAxisTick: React.FC<CustomXAxisTickProps> = ({ x, y, payload, isWeekend }) => {
  const displayDate = getDateOnly(payload.value);

  return (
    <g transform={`translate(${x},${y})`}>
      <text
        x={0}
        y={0}
        dy={16}
        textAnchor="middle"
        fill={isWeekend ? '#ef4444' : '#374151'}
        fontSize="12"
      >
        {displayDate}
      </text>
    </g>
  );
};
